
import AdminClients from "./AdminClients.jsx";
import AdminWebsites from "./AdminWebsites.jsx";
import AdminStatistics from "./AdminStatistics.jsx";

export default function AdminDisplay({admin, display, theme}) {
    const showDisplay = ()=>{
        switch(display){
            case 0:{return <AdminClients clients={admin.clients} theme={theme}/>}
            case 1:{return <AdminWebsites admin={admin} websites={admin.websites} theme={theme}/>}
            case 2:{return <AdminStatistics admin={admin} theme={theme}/>}
            default:{return <AdminClients clients={admin.clients}/>}
        }
    }
    return (
    <div className='adminDisplay' style={{backgroundColor:theme.secondary_color, color:theme.accent_color}}>
        {showDisplay()}
    </div>
  )
}
